import {
  UserApi, Document, PartnersApi, Settings,
} from '@compassdigital/foodworks.ts.sdk';
import UserModule from '@/store/modules/user';
import Format from '@/util/Format';
import AppModule from '@/store/modules/app';
import { IMarketRestaurantInfo } from '@/interface/marketInfo';
import PartnerUtil from '@/util/PartnerUtil';

export default class Service {
  public static async getScouts() {
    try {
      const api = new UserApi(AppModule.apiConfig);
      const users = await api.getUsers();
      return Format.usersListFormatted(users.data);
    } catch (err) {
      throw err;
    }
  }

  /**
   * common api to invite user to logged in portal
   * @param email
   */
  public static async sendInvitation(userEmail: string) {
    try {
      const api = new UserApi(AppModule.apiConfig);
      const user = await api.forgotPassword({ email: userEmail });
      return user;
    } catch (err) {
      const { error } = err.response.data;
      const errorMessage = error.message;
      return errorMessage;
    }
  }

  /**
   * approver user status
   */
  public static approverUser() {
    const approverStatus = UserModule.currentUser ? UserModule.currentUser.is : null;
    const currentUserRole = UserModule.currentRole;
    const { approver } = approverStatus as any;
    const fwManagerApprover = currentUserRole === 'fw_manager' && approver;
    const adminApprover = currentUserRole === 'fw_admin';
    if (fwManagerApprover || adminApprover) {
      return true;
    }
    return false;
  }

  /**
   * Non approver user status
   */
  public static nonApproverUser() {
    const approverStatus = UserModule.currentUser ? UserModule.currentUser.is : null;
    const currentUserRole = UserModule.currentRole;
    const { approver } = approverStatus as any;
    const fwManagerApprover = currentUserRole === 'fw_manager' && !approver;
    const onBoardPartner = currentUserRole === 'partner_owner';
    if (fwManagerApprover || onBoardPartner) {
      return true;
    }
    return false;
  }

  /**
   * get form expiry status
   @param expDate
   */
  public static getDocumentExpire(expDate: any) {
    const currentDate: any = Format.getCurrentDate();
    const date1: any = new Date(expDate);
    const date2: any = new Date(currentDate);
    if (date1 > date2) {
      const diffTime = Math.abs(date1 - date2);
      const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
      return diffDays;
    }
    return null;
  }

  /**
   * get the status of expiry date
   @param documentsSync
   */
  public static getdocumentExpiryForm(documentsSync: Array<Document>) {
    const docs = !documentsSync || documentsSync.map((doc: Document) => {
      const { expiryDate } = doc;
      if (expiryDate) {
        const expiryValue = this.getDocumentExpire(expiryDate);
        if (expiryValue === null) {
          return true;
        }
        return false;
      }
      return false;
    });
    let formStatus: boolean = false;
    const user = !docs || docs.map((document) => {
      if (document) {
        formStatus = true;
        return formStatus;
      }
      return formStatus;
    });
    return formStatus;
  }

  /**
   * get the status of rejected form
   @param documentsSync
   */
  public static getdocumentRejected(documentsSync: any) {
    const docs = !documentsSync || documentsSync.map((doc: any) => {
      const { status } = doc;
      if (status === 'rejected') {
        return true;
      }
      return false;
    });
    let formStatus: boolean = false;
    const user = !docs || docs.map((documet: any) => {
      if (documet) {
        formStatus = true;
        return formStatus;
      }
      return formStatus;
    });
    return formStatus;
  }

  /**
   * update the partner document
   @param restaurantInfoLocal
   @param restaurantID
   */
  public static async patchRestaurant(
    restaurantID: string, restaurantInfoLocal: IMarketRestaurantInfo,
  ) {
    const restInfo: any = { ...restaurantInfoLocal };
    const { phone } = restInfo.businessNumber;
    if (phone) {
      restInfo.businessNumber.phone = Format.CheckMaskNumber(phone);
    } else {
      restInfo.businessNumber.phone = Number(
        restInfo.businessNumber.phone,
      );
    }

    const cuisines: Settings[] = [];
    cuisines.push(restInfo.cuisineTypes);
    restInfo.cuisineTypes = cuisines;

    restInfo.deliveryPartners = PartnerUtil.filterDeliveryPartners(
      restInfo.deliveryPartners,
    );

    const locationFood: Settings[] = [];
    let locationFoodOther = '';
    if (restInfo.foodPrepLocation) {
      const location = restInfo.foodPrepLocation;
      if (location === 'Others') {
        locationFoodOther = restInfo.foodPrepLocOther;
        restInfo.foodPrepLocOther = locationFoodOther;
      }
      locationFood.push(restInfo.foodPrepLocation);
      restInfo.foodPrepLocation = locationFood;
    }

    try {
      const api = new PartnersApi(AppModule.apiConfig);
      const restaurant = await api.patchPartnerById(restInfo.id, restInfo);
      return restaurant;
    } catch (err) {
      const { error } = err.response.data;
      return error.message;
    }
  }
}
